import { AUDIO_EVENTS } from '../constants';
export var NATIVE_EVENTS = [
    'progress',
    'abort',
    'error',
    'canplaythrough',
    'durationchange',
    'timeupdate',
    'volumechange',
    'loadedmetadata',
    'ratechange',
];
var AudioEvents = /** @class */ (function () {
    function AudioEvents(eventEmitter, audioElement) {
        var _this = this;
        this._processEventFromAudio = function (event) {
            switch (event.type) {
                case 'durationchange': {
                    _this._eventEmitter.emit(AUDIO_EVENTS.DURATION_CHANGED, _this._audioElement.duration);
                    break;
                }
                case 'timeupdate': {
                    _this._eventEmitter.emit(AUDIO_EVENTS.TIME_UPDATED, _this._audioElement.currentTime);
                    break;
                }
                case 'loadedmetadata':
                case 'progress': {
                    _this._checkBufferChanges();
                    break;
                }
                case 'volumechange': {
                    _this._checkVolumeChanges();
                    break;
                }
                case 'ratechange': {
                    _this._eventEmitter.emit(AUDIO_EVENTS.RATE_CHANGED, _this._audioElement.playbackRate);
                    break;
                }
                case 'canplaythrough': {
                    _this._eventEmitter.emit(AUDIO_EVENTS.CAN_PLAY_TROUGH);
                    break;
                }
                case 'abort': {
                    _this._eventEmitter.emit(AUDIO_EVENTS.ABORT);
                    break;
                }
                case 'error': {
                    _this._eventEmitter.emit(AUDIO_EVENTS.ERROR, _this._audioElement.error);
                    break;
                }
                default:
            }
        };
        this._eventEmitter = eventEmitter;
        this._audioElement = audioElement;
        this._currentMute = this._audioElement.muted;
        this._currentVolume = this._audioElement.volume;
        this._currentBuffer = this._audioElement.buffered;
        this._bindEvents();
    }
    AudioEvents.prototype._bindEvents = function () {
        var _this = this;
        NATIVE_EVENTS.forEach(function (event) {
            return _this._audioElement.addEventListener(event, _this._processEventFromAudio);
        });
    };
    AudioEvents.prototype._unbindEvents = function () {
        var _this = this;
        NATIVE_EVENTS.forEach(function (event) {
            return _this._audioElement.removeEventListener(event, _this._processEventFromAudio);
        });
    };
    AudioEvents.prototype._checkVolumeChanges = function () {
        var audio = this._audioElement;
        if (this._currentVolume !== audio.volume) {
            this._currentVolume = audio.volume;
            this._eventEmitter.emit(AUDIO_EVENTS.VOLUME_CHANGED, this._currentVolume);
        }
        if (this._currentMute !== audio.muted) {
            this._currentMute = audio.muted;
            this._eventEmitter.emit(AUDIO_EVENTS.MUTE_CHANGED, this._currentMute);
        }
    };
    AudioEvents.prototype._checkBufferChanges = function () {
        var audio = this._audioElement;
        if (this._currentBuffer !== audio.buffered) {
            var buffered = this._audioElement.buffered;
            var duration = this._audioElement.duration;
            var bufferProgress = 0;
            if (duration && buffered.length) {
                bufferProgress = buffered.end(buffered.length - 1) / duration;
            }
            this._eventEmitter.emit(AUDIO_EVENTS.BUFFER_UPDATED, bufferProgress);
        }
    };
    AudioEvents.prototype.destroy = function () {
        this._unbindEvents();
        delete this._audioElement;
        delete this._eventEmitter;
    };
    return AudioEvents;
}());
export default AudioEvents;
//# sourceMappingURL=audio-events.js.map